import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfParayWasl = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RB_para$, RB_paraRRR, PD_parayesta_RRR } = value;
          return (
            <>
              {/* second row */}
              <div className="row pt2">
                <div className="col-lg-10 col-12">
                  <div className="row ">
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={Number(RB_para$).toFixed(2)}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning tc  mt1">پارە بە دۆلار</h3>
                    </div>
                    <div className="col-lg-2 col-4"></div>
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={Number(RB_paraRRR).toFixed(2)}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4 mt1">
                      <h3 className="text-warning tc ">RRR پارە بە </h3>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer rased Remembe */}
              <div className="row pt2">
                <div className="col-lg-10 col-12">
                  <div className="row ">
                    <div className="col-lg-3 col-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={Number(PD_parayesta_RRR).toFixed(2)}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-4">
                      <h3 className="text-warning tc  mt1">RRR ڕەسیدی</h3>
                    </div>
                    <div className="col-lg-2 col-4"></div>
                    <div className="col-lg-3 col-4">
                      {/* <h3 className="bg-white tc mt2"><NumberFormat displayType='text' thousandSeparator={true} value={Number(RB_paraRRR).toFixed(2)} /></h3> */}
                    </div>
                    <div className="col-lg-2 col-4 mt1">
                      {/* <h3 className="text-warning tc ">RRR پارە بە </h3> */}
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* third row */}
              <br />
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfParayWasl;
